import React, { useEffect, createElement } from 'react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbPixelInitialized: boolean;
  }
}
export const MetaPixel = () => {
  useEffect(() => {
    // Check if pixel has already been initialized to prevent double initialization
    if (window._fbPixelInitialized) {
      return;
    }
    // Mark as initialized
    window._fbPixelInitialized = true;
    // Add Meta Pixel base code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1027548898756291');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1027548898756291&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Cleanup function
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
      window._fbPixelInitialized = false;
    };
  }, []);
  return null;
};
// Helper function to track product clicks
export const trackProductClick = () => {
  if (window.fbq) {
    window.fbq('trackCustom', 'ClickToProductPage');
  }
};